import { createContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'

const bodyModalClass = 'has-modal'

export const ModalContext = createContext()

const ModalProvider = (props) => {
  const { children } = props

  // states
  const [stateClass, setStateClass] = useState(false)
  const [modalIsActive, setModalIsActive] = useState(false)
  const [modalType, setModalType] = useState(false)
  const [modalRoute, setModalRoute] = useState(false)
  const [modalReturn, setModalReturn] = useState(false)
  const [modalResponse, setModalResponse] = useState(false)
  const [modalId, setModalId] = useState(false)
  const [modalPlaylist, setModalPlaylist] = useState(false)
  const [modalMandatory, setModalMandatory] = useState(false)
  const [modalModifier, setModalModifier] = useState('')
  const [modalHook, setModalHook] = useState(false)
  const [modalDialog, setModalDialog] = useState(false)
  const [modalScrollTop, setModalScrollTop] = useState(false)
  const [modalPrompt, setModalPrompt] = useState(false)
  const [modalCanPrompt, setModalCanPrompt] = useState(false)
  const [modalHasPrompt, setModalHasPrompt] = useState(false)
  const [modalPromptRedirect, setModalPromptRedirect] = useState(false)
  const [modalFrameActive, setModalFrameActive] = useState(false)
  const [modalFrameInput, setModalFrameInput] = useState(null)
  const [modalFrameOutput, setModalFrameOutput] = useState(null)
  const [modalHasFramePrompt, setModalHasFramePrompt] = useState(false)
  const [modalIsDirty, setModalIsDirty] = useState(false)
  const [modalPromptTrigger, setModalPromptTrigger] = useState(false)
  const [modalIsIndoor, setModalIsIndoor] = useState(false)
  const [modalIsNextPage, setModalIsNextPage] = useState(false)

  useEffect(() => {
    document.body.classList.toggle(bodyModalClass, modalIsActive)
  }, [modalIsActive])

  const openModal = (data) => {
    if (data.route) setModalRoute(data.route)
    if (data.response) setModalResponse(data.response)
    if (data.id) setModalId(data.id)
    if (data.playlist) setModalPlaylist(data.playlist)
    if (data.mandatory) setModalMandatory(data.mandatory)
    if (data.type) setModalType(data.type)
    if (!modalIsActive) setModalIsActive(true)
    setModalModifier(data.modifier ? data.modifier : '')
  }

  const updateModalHooks = async (types) => {
    const check = {}
    if (!types) return false
    for (const [type, value] of Object.entries(types)) {
      const hookUpdateResponse = await fetch(`/api/knvb/hook?hook=${type}&value=${value}`)
      const hookUpdateResults = await hookUpdateResponse.json()
      if (hookUpdateResults.code === 200) check[type] = true
    }
    setModalHook(check)
    return check !== {}
  }

  return (
    <ModalContext.Provider
      value={{
        stateClass,
        setStateClass,
        modalIsActive,
        setModalIsActive,
        modalType,
        setModalType,
        modalRoute,
        setModalRoute,
        modalReturn,
        setModalReturn,
        modalResponse,
        setModalResponse,
        modalId,
        setModalId,
        modalPlaylist,
        setModalPlaylist,
        modalMandatory,
        setModalMandatory,
        modalModifier,
        setModalModifier,
        openModal,
        updateModalHooks,
        modalHook,
        setModalHook,
        modalDialog,
        setModalDialog,
        modalCanPrompt,
        setModalCanPrompt,
        modalPrompt,
        setModalPrompt,
        modalHasPrompt,
        setModalHasPrompt,
        modalScrollTop,
        setModalScrollTop,
        modalPromptRedirect,
        setModalPromptRedirect,
        modalFrameActive,
        setModalFrameActive,
        modalFrameInput,
        setModalFrameInput,
        modalFrameOutput,
        setModalFrameOutput,
        modalHasFramePrompt,
        setModalHasFramePrompt,
        modalIsDirty,
        setModalIsDirty,
        modalIsNextPage,
        setModalIsNextPage,
        modalPromptTrigger,
        setModalPromptTrigger,
        modalIsIndoor,
        setModalIsIndoor
      }}
    >
      {/* eslint-disable-next-line react/prop-types */}
      {children}
    </ModalContext.Provider>
  )
}

ModalProvider.propTypes = {
  children: PropTypes.object
}

export default ModalProvider
